import { render, staticRenderFns } from "./pubcommerce.vue?vue&type=template&id=815058ea&scoped=true&"
import script from "./pubcommerce.vue?vue&type=script&lang=js&"
export * from "./pubcommerce.vue?vue&type=script&lang=js&"
import style0 from "./pubcommerce.vue?vue&type=style&index=0&id=815058ea&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815058ea",
  null
  
)

export default component.exports